import { render, staticRenderFns } from "./SvgInclude.vue?vue&type=template&id=21767e39&scoped=true"
import script from "./SvgInclude.vue?vue&type=script&lang=ts"
export * from "./SvgInclude.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21767e39",
  null
  
)

export default component.exports